/**
 * Jede Seite hat Lade-, Fehler- und Leerzustand (CLAUDE.md). Diese Hülle nimmt ein TanStack-Query-Ergebnis
 * und rendert Skeleton (nach 300 ms), Notice mit „Erneut versuchen“ oder den Inhalt.
 */
import type { ReactNode } from "react";
import type { UseQueryResult } from "@tanstack/react-query";
import { Skeleton } from "./Skeleton";
import { Notice } from "./Notice";
import { Button } from "./Button";
import { ApiFehler } from "../api/client";

export function Seitenzustand<T>({
  query,
  lines = 4,
  thumb,
  leer,
  istLeer,
  children,
}: {
  query: UseQueryResult<T>;
  lines?: number;
  thumb?: boolean;
  /** Wird gezeigt, wenn `istLeer(data)` true liefert. */
  leer?: ReactNode;
  istLeer?: (data: T) => boolean;
  children: (data: T) => ReactNode;
}) {
  if (query.isPending) return <Skeleton lines={lines} thumb={thumb} />;
  if (query.isError) {
    const f = query.error;
    const meldung = f instanceof ApiFehler ? f.message : "Die Daten konnten nicht geladen werden.";
    const status = f instanceof ApiFehler ? f.status : 0;
    if (status === 401) {
      return (
        <Notice tone="attention" title="Nicht angemeldet" action={<Button variant="primary" onClick={() => window.location.assign("/anmelden")}>Anmelden</Button>}>
          Bitte melde dich an, dann geht es hier weiter.
        </Notice>
      );
    }
    return (
      <Notice tone="error" title="Das hat nicht geklappt" action={<Button variant="secondary" icon="undo-2" onClick={() => void query.refetch()}>Erneut versuchen</Button>}>
        {meldung}
      </Notice>
    );
  }
  if (istLeer && leer && istLeer(query.data)) return <>{leer}</>;
  return <>{children(query.data)}</>;
}
